// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios'
import store from "./store"
//import Antd from 'ant-design-vue'
//import 'ant-design-vue/dist/antd.css'
import {hasPermission} from "./permission"
// import Print from 'vue-print-nb'

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import {
  ColorPicker,
  Table,
  TableColumn,
  Tag,
  Popover,
  Container,
  Header,
  Footer,
  Main,
  RadioGroup,
  RadioButton,
  ButtonGroup,
  Switch,
  Radio,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxGroup,
  Upload,
  Tooltip,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Badge,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Select, Option,
  Input, Button,
  Form,
  FormItem,
  InputNumber,
  Dialog,
  Slider,
  MessageBox,
  Message,
  Row, Col,
  DatePicker,
  Loading
} from 'element-ui'

Vue.use(ColorPicker);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Container);
Vue.use(Header);
Vue.use(Footer);
Vue.use(Main);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(ButtonGroup);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Upload);
Vue.use(Tooltip);
Vue.use(Drawer);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Badge);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Slider)
Vue.use(Button)

Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)


Vue.use(Loading.directive)
//Vue.use(Antd)
Vue.use(hasPermission)
//Vue.use(Print)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$axios = axios

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js